/**
 * For reference: https://bulma.io/documentation/modifiers/syntax/
 */

import classNames from 'classnames';

export interface ISizeModifier {
	isSmall?: boolean;
	isMedium?: boolean;
	isNormal?: boolean;
	isLarge?: boolean;
}

export function getSizeModifierClasses(modifiers: ISizeModifier) {
	return classNames(
		modifiers.isSmall && 'is-small',
		modifiers.isMedium && 'is-medium',
		modifiers.isNormal && 'is-normal',
		modifiers.isLarge && 'is-large'
	);
}
